<template>
  <div v-if="questions && currentQuestionIndex < 5">
    <div class="answers-container">
      <div class="question-word">{{ serviceTexts.question }}</div>
      <img
          class="question-number"
          :src="getImagePath(currentQuestionIndex + 1)"
          alt="logo"
      />
      <h1 class="question-text">{{ questions[(currentQuestionIndex + randomShift) % questions.length].question }}</h1>
      <div class="flex-grow"></div>
      <div class="buttons">
        <div
            class="button-answer"
            v-for="(answer, index) in shuffledAnswers"
            :key="index"
            @click="selectAnswer(answer.points)"
        >
          {{ answer.text }}
        </div>
      </div>
    </div>
  </div>

  <ResultComponent v-else :score="score" :language="language" :serviceTexts="serviceTexts" />

  <div v-if="isModalVisible" class="modal-overlay">
    <div class="modal-content">
      <img class="fact-image" src="@/assets/images/fun-fact.png" alt="logo" />
      <div>{{ randomFact }}</div>
      <div class="flex-grow"></div>
      <button @click="nextQuestion">
        {{ currentQuestionIndex === 4 ? serviceTexts.finish : serviceTexts.next }}
      </button>
    </div>
  </div>
</template>
<script>
import questionsData from '@/assets/questions.json';
import factsData from '@/assets/facts.json';
import serviceData from '@/assets/service.json';
import ResultComponent from "@/components/ResultComponent.vue";

export default {
  components: { ResultComponent },
  props: {
    language: String,
    onComplete: Function,
  },
  computed: {
    shuffledAnswers() {
      const questionIndex = (this.currentQuestionIndex + this.randomShift) % this.questions.length;
      const answers = [...this.questions[questionIndex].answers]; // Создаем копию массива
      return this.shuffleArray(answers);
    },
  },
  data() {
    return {
      questions: [],
      currentQuestionIndex: 0,
      score: 0,
      facts: [],
      randomShift: Math.floor(Math.random() * 11),
      displayedFacts: new Set(),
      randomFact: '',
      isModalVisible: false,
      serviceTexts: {
        next: 'Next',
        finish: 'Finish',
      },
    };
  },
  watch: {
    language(newLang) {
      this.loadContent(newLang);
    },
  },
  created() {
    this.loadContent(this.language);
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    getImagePath(index) {
      return require(`@/assets/images/answers/hexagons_${index}.png`);
    },
    loadContent(language) {
      if (questionsData[language]) {
        this.questions = questionsData[language];
      }
      if (factsData[language]) {
        this.facts = factsData[language];
        this.randomFact = this.getFactWithShift();
      }
      if (serviceData[language]) {
        this.serviceTexts = serviceData[language];
      }
    },
    selectAnswer(points) {
      this.score += points;
      this.randomFact = this.getFactWithShift();
      this.isModalVisible = true;
    },
    getFactWithShift() {
      const factIndex = (this.currentQuestionIndex + this.randomShift) % this.facts.length;
      return this.facts[factIndex];
    },
    nextQuestion() {
      this.isModalVisible = false;
      this.currentQuestionIndex++;
    },
  },
};

</script>
